import React from 'react';

import { citations, reactions, substances } from '@Constants';

import AvailableRelativeContextButton from './AvailableRelativeContextButton';


export default function TargetsRelativeContextsList (props) {
  const {
    availableRelativeContext,
  } = props;

  const citationsItem = availableRelativeContext.get(citations);
  const reactionsItem = availableRelativeContext.get(reactions);
  const substancesItem = availableRelativeContext.get(substances);

  return (
    <>
      {
        citationsItem && (
          <>
            <span className="hide-below-laptop">out of&nbsp;</span>
            <AvailableRelativeContextButton {...props} item={citationsItem}/>
          </>
        )
      }
      {
        substancesItem && (
          <>
            ,&nbsp;
            <AvailableRelativeContextButton {...props} item={substancesItem}/>
          </>
        )
      }
      {
        reactionsItem && (
          <>
            ,&nbsp;
            <AvailableRelativeContextButton {...props} item={reactionsItem}/>

          </>
        )
      }
    </>
  );
}
